import {IScheduleReport} from '../../interfaces/IScheduleReport';
import {TableColumn} from '@vidazoo/ui-kit';

export const ScheduleReportsTableColumns: TableColumn<IScheduleReport>[] = [
    {
        title: 'Name',
        key: 'name',
        defaultWidth: 100,
        options: {search: {searchKey: 'name'}, freeze: true, sort: {sortKey: 'name'}}
    },
    {
        title: "Schedule",
        key: "schedule",
        defaultWidth: 100,
        options: {search: {searchKey: 'schedule'}, freeze: true, sort: {sortKey: 'schedule'}}
    }, {
        title: "Date Range",
        key: "dateRange",
        defaultWidth: 100,
        options: {search: {searchKey: 'dateRange'}, freeze: true, sort: {sortKey: 'dateRange'}}
    }, {
        title: "Last Schedule",
        key: "lastSchedule",
        defaultWidth: 100,
        options: {search: {searchKey: 'lastSchedule'}, freeze: true, sort: {sortKey: 'lastSchedule'}}
    }, {
        title: "Next Schedule",
        key: "nextSchedule",
        defaultWidth: 100,
        options: {search: {searchKey: 'nextSchedule'}, freeze: true, sort: {sortKey: 'nextSchedule'}}
    }, {
        title: "Created",
        key: "created",
        defaultWidth: 100,
        options: {search: {searchKey: 'created'}, freeze: true, sort: {sortKey: 'created'}}
    }, {
        title: "Active",
        key: "isActive",
        defaultWidth: 100,
        options: {
            search: {searchKey: 'isActive'},
            sort: {sortKey: 'isActive'},
            freeze: true,
        }
    }, {
        title: "Actions",
        key: "actions",
        defaultWidth: 100,
    }
];
